export enum ButtonTypes {
  SUBMIT = 'submit_button',
  VALIDATION_MODAL_SUBMIT = 'validation_modal_submit_button',
  COVERAGE_SUBMIT = 'coverage_submit_button',
  NAVIGATION = 'navigation_button',
  HREF = 'href_button',
  MODAL = 'modal_button',
  RELOAD = 'reload_button',
  BACK = 'back_button',
  ACTION = 'action_button',
  PDF_DOWNLOAD = 'pdf_download_button',
}

export enum ButtonSizes {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export enum ButtonColors {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  INFO = 'info',
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  TEXT = 'text',
}

export enum ButtonVariants {
  TEXT = 'text',
  OUTLINED = 'outlined',
  CONTAINED = 'contained',
  CHIP = 'chip',
}
